// source: assistant-provider.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.assistant_api.AssistantProviderAgentflow', null, global);
goog.exportSymbol('proto.assistant_api.AssistantProviderAgentkit', null, global);
goog.exportSymbol('proto.assistant_api.AssistantProviderModel', null, global);
goog.exportSymbol('proto.assistant_api.AssistantProviderWebsocket', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantProviderRequest', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantProviderRequest.AssistantproviderCase', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket', null, global);
goog.exportSymbol('proto.assistant_api.GetAllAssistantProviderRequest', null, global);
goog.exportSymbol('proto.assistant_api.GetAllAssistantProviderResponse', null, global);
goog.exportSymbol('proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider', null, global);
goog.exportSymbol('proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.AssistantproviderCase', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantProviderResponse', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantProviderResponse.DataCase', null, global);
goog.exportSymbol('proto.assistant_api.UpdateAssistantVersionRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.UpdateAssistantVersionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.UpdateAssistantVersionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.UpdateAssistantVersionRequest.displayName = 'proto.assistant_api.UpdateAssistantVersionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantProviderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.assistant_api.CreateAssistantProviderRequest.oneofGroups_);
};
goog.inherits(proto.assistant_api.CreateAssistantProviderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantProviderRequest.displayName = 'proto.assistant_api.CreateAssistantProviderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.displayName = 'proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.displayName = 'proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.displayName = 'proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.displayName = 'proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantProviderAgentkit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.assistant_api.AssistantProviderAgentkit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantProviderAgentkit.displayName = 'proto.assistant_api.AssistantProviderAgentkit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantProviderWebsocket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.assistant_api.AssistantProviderWebsocket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantProviderWebsocket.displayName = 'proto.assistant_api.AssistantProviderWebsocket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantProviderModel = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, proto.assistant_api.AssistantProviderModel.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.AssistantProviderModel, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantProviderModel.displayName = 'proto.assistant_api.AssistantProviderModel';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantProviderAgentflow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.assistant_api.AssistantProviderAgentflow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantProviderAgentflow.displayName = 'proto.assistant_api.AssistantProviderAgentflow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAllAssistantProviderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.GetAllAssistantProviderRequest.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.GetAllAssistantProviderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAllAssistantProviderRequest.displayName = 'proto.assistant_api.GetAllAssistantProviderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantProviderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.assistant_api.GetAssistantProviderResponse.oneofGroups_);
};
goog.inherits(proto.assistant_api.GetAssistantProviderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantProviderResponse.displayName = 'proto.assistant_api.GetAssistantProviderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAllAssistantProviderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.GetAllAssistantProviderResponse.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.GetAllAssistantProviderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAllAssistantProviderResponse.displayName = 'proto.assistant_api.GetAllAssistantProviderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.oneofGroups_);
};
goog.inherits(proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.displayName = 'proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.UpdateAssistantVersionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.UpdateAssistantVersionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.UpdateAssistantVersionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.UpdateAssistantVersionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantproviderid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    assistantprovider: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.UpdateAssistantVersionRequest}
 */
proto.assistant_api.UpdateAssistantVersionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.UpdateAssistantVersionRequest;
  return proto.assistant_api.UpdateAssistantVersionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.UpdateAssistantVersionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.UpdateAssistantVersionRequest}
 */
proto.assistant_api.UpdateAssistantVersionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantproviderid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssistantprovider(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.UpdateAssistantVersionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.UpdateAssistantVersionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.UpdateAssistantVersionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.UpdateAssistantVersionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantproviderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getAssistantprovider();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantVersionRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantVersionRequest} returns this
 */
proto.assistant_api.UpdateAssistantVersionRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantProviderId = 2;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantVersionRequest.prototype.getAssistantproviderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantVersionRequest} returns this
 */
proto.assistant_api.UpdateAssistantVersionRequest.prototype.setAssistantproviderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional string assistantProvider = 3;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantVersionRequest.prototype.getAssistantprovider = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantVersionRequest} returns this
 */
proto.assistant_api.UpdateAssistantVersionRequest.prototype.setAssistantprovider = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.assistant_api.CreateAssistantProviderRequest.oneofGroups_ = [[50,51,52,53]];

/**
 * @enum {number}
 */
proto.assistant_api.CreateAssistantProviderRequest.AssistantproviderCase = {
  ASSISTANTPROVIDER_NOT_SET: 0,
  MODEL: 50,
  AGENTKIT: 51,
  WEBSOCKET: 52,
  AGENTFLOW: 53
};

/**
 * @return {proto.assistant_api.CreateAssistantProviderRequest.AssistantproviderCase}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.getAssistantproviderCase = function() {
  return /** @type {proto.assistant_api.CreateAssistantProviderRequest.AssistantproviderCase} */(jspb.Message.computeOneofCase(this, proto.assistant_api.CreateAssistantProviderRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantProviderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantProviderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantProviderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    model: (f = msg.getModel()) && proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.toObject(includeInstance, f),
    agentkit: (f = msg.getAgentkit()) && proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.toObject(includeInstance, f),
    websocket: (f = msg.getWebsocket()) && proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.toObject(includeInstance, f),
    agentflow: (f = msg.getAgentflow()) && proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest}
 */
proto.assistant_api.CreateAssistantProviderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantProviderRequest;
  return proto.assistant_api.CreateAssistantProviderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantProviderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest}
 */
proto.assistant_api.CreateAssistantProviderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 50:
      var value = new proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel;
      reader.readMessage(value,proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.deserializeBinaryFromReader);
      msg.setModel(value);
      break;
    case 51:
      var value = new proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit;
      reader.readMessage(value,proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.deserializeBinaryFromReader);
      msg.setAgentkit(value);
      break;
    case 52:
      var value = new proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket;
      reader.readMessage(value,proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.deserializeBinaryFromReader);
      msg.setWebsocket(value);
      break;
    case 53:
      var value = new proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow;
      reader.readMessage(value,proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.deserializeBinaryFromReader);
      msg.setAgentflow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantProviderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantProviderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantProviderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getModel();
  if (f != null) {
    writer.writeMessage(
      50,
      f,
      proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.serializeBinaryToWriter
    );
  }
  f = message.getAgentkit();
  if (f != null) {
    writer.writeMessage(
      51,
      f,
      proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.serializeBinaryToWriter
    );
  }
  f = message.getWebsocket();
  if (f != null) {
    writer.writeMessage(
      52,
      f,
      proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.serializeBinaryToWriter
    );
  }
  f = message.getAgentflow();
  if (f != null) {
    writer.writeMessage(
      53,
      f,
      proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.repeatedFields_ = [23];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.toObject = function(includeInstance, msg) {
  var f, obj = {
    template: (f = msg.getTemplate()) && common_pb.TextChatCompletePrompt.toObject(includeInstance, f),
    modelprovidername: jspb.Message.getFieldWithDefault(msg, 22, ""),
    assistantmodeloptionsList: jspb.Message.toObjectList(msg.getAssistantmodeloptionsList(),
    common_pb.Metadata.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel;
  return proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 20:
      var value = new common_pb.TextChatCompletePrompt;
      reader.readMessage(value,common_pb.TextChatCompletePrompt.deserializeBinaryFromReader);
      msg.setTemplate(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelprovidername(value);
      break;
    case 23:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addAssistantmodeloptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTemplate();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      common_pb.TextChatCompletePrompt.serializeBinaryToWriter
    );
  }
  f = message.getModelprovidername();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getAssistantmodeloptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      23,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
};


/**
 * optional TextChatCompletePrompt template = 20;
 * @return {?proto.TextChatCompletePrompt}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.getTemplate = function() {
  return /** @type{?proto.TextChatCompletePrompt} */ (
    jspb.Message.getWrapperField(this, common_pb.TextChatCompletePrompt, 20));
};


/**
 * @param {?proto.TextChatCompletePrompt|undefined} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel} returns this
*/
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.setTemplate = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.clearTemplate = function() {
  return this.setTemplate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.hasTemplate = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional string modelProviderName = 22;
 * @return {string}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.getModelprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.setModelprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * repeated Metadata assistantModelOptions = 23;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.getAssistantmodeloptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 23));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel} returns this
*/
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.setAssistantmodeloptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 23, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.addAssistantmodeloptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 23, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel.prototype.clearAssistantmodeloptionsList = function() {
  return this.setAssistantmodeloptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.toObject = function(includeInstance, msg) {
  var f, obj = {
    agentkiturl: jspb.Message.getFieldWithDefault(msg, 10, ""),
    certificate: jspb.Message.getFieldWithDefault(msg, 11, ""),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : [],
    transportsecurity: jspb.Message.getFieldWithDefault(msg, 13, ""),
    tlsverification: jspb.Message.getFieldWithDefault(msg, 14, ""),
    tlsservername: jspb.Message.getFieldWithDefault(msg, 15, ""),
    connecttimeoutms: jspb.Message.getFieldWithDefault(msg, 16, 0),
    keepalivetimems: jspb.Message.getFieldWithDefault(msg, 17, 0),
    keepalivetimeoutms: jspb.Message.getFieldWithDefault(msg, 18, 0),
    maxrecvmessagebytes: jspb.Message.getFieldWithDefault(msg, 19, 0),
    maxsendmessagebytes: jspb.Message.getFieldWithDefault(msg, 20, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit;
  return proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgentkiturl(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCertificate(value);
      break;
    case 12:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransportsecurity(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setTlsverification(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setTlsservername(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setConnecttimeoutms(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKeepalivetimems(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKeepalivetimeoutms(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxrecvmessagebytes(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxsendmessagebytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAgentkiturl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCertificate();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(12, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getTransportsecurity();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getTlsverification();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTlsservername();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getConnecttimeoutms();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
  f = message.getKeepalivetimems();
  if (f !== 0) {
    writer.writeUint32(
      17,
      f
    );
  }
  f = message.getKeepalivetimeoutms();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getMaxrecvmessagebytes();
  if (f !== 0) {
    writer.writeUint32(
      19,
      f
    );
  }
  f = message.getMaxsendmessagebytes();
  if (f !== 0) {
    writer.writeUint32(
      20,
      f
    );
  }
};


/**
 * optional string agentKitUrl = 10;
 * @return {string}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.getAgentkiturl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.setAgentkiturl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string certificate = 11;
 * @return {string}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.getCertificate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.setCertificate = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * map<string, string> metadata = 12;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 12, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;};


/**
 * optional string transportSecurity = 13;
 * @return {string}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.getTransportsecurity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.setTransportsecurity = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string tlsVerification = 14;
 * @return {string}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.getTlsverification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.setTlsverification = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string tlsServerName = 15;
 * @return {string}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.getTlsservername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.setTlsservername = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional uint32 connectTimeoutMs = 16;
 * @return {number}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.getConnecttimeoutms = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.setConnecttimeoutms = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional uint32 keepaliveTimeMs = 17;
 * @return {number}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.getKeepalivetimems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.setKeepalivetimems = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional uint32 keepaliveTimeoutMs = 18;
 * @return {number}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.getKeepalivetimeoutms = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.setKeepalivetimeoutms = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional uint32 maxRecvMessageBytes = 19;
 * @return {number}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.getMaxrecvmessagebytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.setMaxrecvmessagebytes = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional uint32 maxSendMessageBytes = 20;
 * @return {number}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.getMaxsendmessagebytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit.prototype.setMaxsendmessagebytes = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.toObject = function(includeInstance, msg) {
  var f, obj = {
    websocketurl: jspb.Message.getFieldWithDefault(msg, 30, ""),
    headersMap: (f = msg.getHeadersMap()) ? f.toObject(includeInstance, undefined) : [],
    connectionparametersMap: (f = msg.getConnectionparametersMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket;
  return proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setWebsocketurl(value);
      break;
    case 31:
      var value = msg.getHeadersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 32:
      var value = msg.getConnectionparametersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWebsocketurl();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getHeadersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(31, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getConnectionparametersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(32, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional string websocketUrl = 30;
 * @return {string}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.prototype.getWebsocketurl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.prototype.setWebsocketurl = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * map<string, string> headers = 31;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.prototype.getHeadersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 31, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.prototype.clearHeadersMap = function() {
  this.getHeadersMap().clear();
  return this;};


/**
 * map<string, string> connectionParameters = 32;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.prototype.getConnectionparametersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 32, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket.prototype.clearConnectionparametersMap = function() {
  this.getConnectionparametersMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.toObject = function(includeInstance, msg) {
  var f, obj = {
    schemaversion: jspb.Message.getFieldWithDefault(msg, 40, ""),
    definition: (f = msg.getDefinition()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow;
  return proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchemaversion(value);
      break;
    case 41:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setDefinition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchemaversion();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getDefinition();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
};


/**
 * optional string schemaVersion = 40;
 * @return {string}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.prototype.getSchemaversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.prototype.setSchemaversion = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional google.protobuf.Struct definition = 41;
 * @return {?proto.google.protobuf.Struct}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.prototype.getDefinition = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 41));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow} returns this
*/
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.prototype.setDefinition = function(value) {
  return jspb.Message.setWrapperField(this, 41, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.prototype.clearDefinition = function() {
  return this.setDefinition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow.prototype.hasDefinition = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional CreateAssistantProviderModel model = 50;
 * @return {?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.getModel = function() {
  return /** @type{?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel, 50));
};


/**
 * @param {?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderModel|undefined} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest} returns this
*/
proto.assistant_api.CreateAssistantProviderRequest.prototype.setModel = function(value) {
  return jspb.Message.setOneofWrapperField(this, 50, proto.assistant_api.CreateAssistantProviderRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.clearModel = function() {
  return this.setModel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.hasModel = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional CreateAssistantProviderAgentkit agentkit = 51;
 * @return {?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.getAgentkit = function() {
  return /** @type{?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit, 51));
};


/**
 * @param {?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentkit|undefined} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest} returns this
*/
proto.assistant_api.CreateAssistantProviderRequest.prototype.setAgentkit = function(value) {
  return jspb.Message.setOneofWrapperField(this, 51, proto.assistant_api.CreateAssistantProviderRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.clearAgentkit = function() {
  return this.setAgentkit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.hasAgentkit = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional CreateAssistantProviderWebsocket websocket = 52;
 * @return {?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.getWebsocket = function() {
  return /** @type{?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket, 52));
};


/**
 * @param {?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderWebsocket|undefined} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest} returns this
*/
proto.assistant_api.CreateAssistantProviderRequest.prototype.setWebsocket = function(value) {
  return jspb.Message.setOneofWrapperField(this, 52, proto.assistant_api.CreateAssistantProviderRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.clearWebsocket = function() {
  return this.setWebsocket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.hasWebsocket = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional CreateAssistantProviderAgentflow agentflow = 53;
 * @return {?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.getAgentflow = function() {
  return /** @type{?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow, 53));
};


/**
 * @param {?proto.assistant_api.CreateAssistantProviderRequest.CreateAssistantProviderAgentflow|undefined} value
 * @return {!proto.assistant_api.CreateAssistantProviderRequest} returns this
*/
proto.assistant_api.CreateAssistantProviderRequest.prototype.setAgentflow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 53, proto.assistant_api.CreateAssistantProviderRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.CreateAssistantProviderRequest} returns this
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.clearAgentflow = function() {
  return this.setAgentflow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantProviderRequest.prototype.hasAgentflow = function() {
  return jspb.Message.getField(this, 53) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantProviderAgentkit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantProviderAgentkit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantProviderAgentkit.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    assistantid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    status: jspb.Message.getFieldWithDefault(msg, 4, ""),
    url: jspb.Message.getFieldWithDefault(msg, 5, ""),
    certificate: jspb.Message.getFieldWithDefault(msg, 6, ""),
    metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : [],
    createdactor: (f = msg.getCreatedactor()) && common_pb.AuditActor.toObject(includeInstance, f),
    updatedactor: (f = msg.getUpdatedactor()) && common_pb.AuditActor.toObject(includeInstance, f),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    transportsecurity: jspb.Message.getFieldWithDefault(msg, 19, ""),
    tlsverification: jspb.Message.getFieldWithDefault(msg, 20, ""),
    tlsservername: jspb.Message.getFieldWithDefault(msg, 21, ""),
    connecttimeoutms: jspb.Message.getFieldWithDefault(msg, 22, 0),
    keepalivetimems: jspb.Message.getFieldWithDefault(msg, 23, 0),
    keepalivetimeoutms: jspb.Message.getFieldWithDefault(msg, 24, 0),
    maxrecvmessagebytes: jspb.Message.getFieldWithDefault(msg, 25, 0),
    maxsendmessagebytes: jspb.Message.getFieldWithDefault(msg, 26, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantProviderAgentkit}
 */
proto.assistant_api.AssistantProviderAgentkit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantProviderAgentkit;
  return proto.assistant_api.AssistantProviderAgentkit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantProviderAgentkit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantProviderAgentkit}
 */
proto.assistant_api.AssistantProviderAgentkit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAssistantid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCertificate(value);
      break;
    case 7:
      var value = msg.getMetadataMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 1000:
      var value = new common_pb.AuditActor;
      reader.readMessage(value,common_pb.AuditActor.deserializeBinaryFromReader);
      msg.setCreatedactor(value);
      break;
    case 1001:
      var value = new common_pb.AuditActor;
      reader.readMessage(value,common_pb.AuditActor.deserializeBinaryFromReader);
      msg.setUpdatedactor(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransportsecurity(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setTlsverification(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setTlsservername(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setConnecttimeoutms(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKeepalivetimems(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setKeepalivetimeoutms(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxrecvmessagebytes(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxsendmessagebytes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantProviderAgentkit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantProviderAgentkit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantProviderAgentkit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssistantid();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCertificate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMetadataMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getCreatedactor();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      common_pb.AuditActor.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedactor();
  if (f != null) {
    writer.writeMessage(
      1001,
      f,
      common_pb.AuditActor.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTransportsecurity();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getTlsverification();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getTlsservername();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getConnecttimeoutms();
  if (f !== 0) {
    writer.writeUint32(
      22,
      f
    );
  }
  f = message.getKeepalivetimems();
  if (f !== 0) {
    writer.writeUint32(
      23,
      f
    );
  }
  f = message.getKeepalivetimeoutms();
  if (f !== 0) {
    writer.writeUint32(
      24,
      f
    );
  }
  f = message.getMaxrecvmessagebytes();
  if (f !== 0) {
    writer.writeUint32(
      25,
      f
    );
  }
  f = message.getMaxsendmessagebytes();
  if (f !== 0) {
    writer.writeUint32(
      26,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 assistantId = 3;
 * @return {number}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getAssistantid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string status = 4;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string certificate = 6;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getCertificate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setCertificate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * map<string, string> metadata = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getMetadataMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.clearMetadataMap = function() {
  this.getMetadataMap().clear();
  return this;};


/**
 * optional AuditActor createdActor = 1000;
 * @return {?proto.AuditActor}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getCreatedactor = function() {
  return /** @type{?proto.AuditActor} */ (
    jspb.Message.getWrapperField(this, common_pb.AuditActor, 1000));
};


/**
 * @param {?proto.AuditActor|undefined} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
*/
proto.assistant_api.AssistantProviderAgentkit.prototype.setCreatedactor = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.clearCreatedactor = function() {
  return this.setCreatedactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.hasCreatedactor = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional AuditActor updatedActor = 1001;
 * @return {?proto.AuditActor}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getUpdatedactor = function() {
  return /** @type{?proto.AuditActor} */ (
    jspb.Message.getWrapperField(this, common_pb.AuditActor, 1001));
};


/**
 * @param {?proto.AuditActor|undefined} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
*/
proto.assistant_api.AssistantProviderAgentkit.prototype.setUpdatedactor = function(value) {
  return jspb.Message.setWrapperField(this, 1001, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.clearUpdatedactor = function() {
  return this.setUpdatedactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.hasUpdatedactor = function() {
  return jspb.Message.getField(this, 1001) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
*/
proto.assistant_api.AssistantProviderAgentkit.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
*/
proto.assistant_api.AssistantProviderAgentkit.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional string transportSecurity = 19;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getTransportsecurity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setTransportsecurity = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string tlsVerification = 20;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getTlsverification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setTlsverification = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string tlsServerName = 21;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getTlsservername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setTlsservername = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional uint32 connectTimeoutMs = 22;
 * @return {number}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getConnecttimeoutms = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setConnecttimeoutms = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional uint32 keepaliveTimeMs = 23;
 * @return {number}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getKeepalivetimems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setKeepalivetimems = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional uint32 keepaliveTimeoutMs = 24;
 * @return {number}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getKeepalivetimeoutms = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setKeepalivetimeoutms = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional uint32 maxRecvMessageBytes = 25;
 * @return {number}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getMaxrecvmessagebytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setMaxrecvmessagebytes = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional uint32 maxSendMessageBytes = 26;
 * @return {number}
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.getMaxsendmessagebytes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantProviderAgentkit} returns this
 */
proto.assistant_api.AssistantProviderAgentkit.prototype.setMaxsendmessagebytes = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantProviderWebsocket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantProviderWebsocket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantProviderWebsocket.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    assistantid: jspb.Message.getFieldWithDefault(msg, 3, 0),
    url: jspb.Message.getFieldWithDefault(msg, 5, ""),
    headersMap: (f = msg.getHeadersMap()) ? f.toObject(includeInstance, undefined) : [],
    parametersMap: (f = msg.getParametersMap()) ? f.toObject(includeInstance, undefined) : [],
    status: jspb.Message.getFieldWithDefault(msg, 12, ""),
    createdactor: (f = msg.getCreatedactor()) && common_pb.AuditActor.toObject(includeInstance, f),
    updatedactor: (f = msg.getUpdatedactor()) && common_pb.AuditActor.toObject(includeInstance, f),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantProviderWebsocket}
 */
proto.assistant_api.AssistantProviderWebsocket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantProviderWebsocket;
  return proto.assistant_api.AssistantProviderWebsocket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantProviderWebsocket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantProviderWebsocket}
 */
proto.assistant_api.AssistantProviderWebsocket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAssistantid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 6:
      var value = msg.getHeadersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 7:
      var value = msg.getParametersMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 1000:
      var value = new common_pb.AuditActor;
      reader.readMessage(value,common_pb.AuditActor.deserializeBinaryFromReader);
      msg.setCreatedactor(value);
      break;
    case 1001:
      var value = new common_pb.AuditActor;
      reader.readMessage(value,common_pb.AuditActor.deserializeBinaryFromReader);
      msg.setUpdatedactor(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantProviderWebsocket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantProviderWebsocket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantProviderWebsocket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssistantid();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHeadersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(6, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getParametersMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(7, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCreatedactor();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      common_pb.AuditActor.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedactor();
  if (f != null) {
    writer.writeMessage(
      1001,
      f,
      common_pb.AuditActor.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 assistantId = 3;
 * @return {number}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.getAssistantid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * map<string, string> headers = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.getHeadersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 6, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.clearHeadersMap = function() {
  this.getHeadersMap().clear();
  return this;};


/**
 * map<string, string> parameters = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.getParametersMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 7, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.clearParametersMap = function() {
  this.getParametersMap().clear();
  return this;};


/**
 * optional string status = 12;
 * @return {string}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional AuditActor createdActor = 1000;
 * @return {?proto.AuditActor}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.getCreatedactor = function() {
  return /** @type{?proto.AuditActor} */ (
    jspb.Message.getWrapperField(this, common_pb.AuditActor, 1000));
};


/**
 * @param {?proto.AuditActor|undefined} value
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
*/
proto.assistant_api.AssistantProviderWebsocket.prototype.setCreatedactor = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.clearCreatedactor = function() {
  return this.setCreatedactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.hasCreatedactor = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional AuditActor updatedActor = 1001;
 * @return {?proto.AuditActor}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.getUpdatedactor = function() {
  return /** @type{?proto.AuditActor} */ (
    jspb.Message.getWrapperField(this, common_pb.AuditActor, 1001));
};


/**
 * @param {?proto.AuditActor|undefined} value
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
*/
proto.assistant_api.AssistantProviderWebsocket.prototype.setUpdatedactor = function(value) {
  return jspb.Message.setWrapperField(this, 1001, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.clearUpdatedactor = function() {
  return this.setUpdatedactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.hasUpdatedactor = function() {
  return jspb.Message.getField(this, 1001) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
*/
proto.assistant_api.AssistantProviderWebsocket.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
*/
proto.assistant_api.AssistantProviderWebsocket.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderWebsocket} returns this
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderWebsocket.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 18) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantProviderModel.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantProviderModel.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantProviderModel.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantProviderModel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantProviderModel.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    template: (f = msg.getTemplate()) && common_pb.TextChatCompletePrompt.toObject(includeInstance, f),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    assistantid: jspb.Message.getFieldWithDefault(msg, 4, 0),
    modelprovidername: jspb.Message.getFieldWithDefault(msg, 7, ""),
    assistantmodeloptionsList: jspb.Message.toObjectList(msg.getAssistantmodeloptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    status: jspb.Message.getFieldWithDefault(msg, 12, ""),
    createdactor: (f = msg.getCreatedactor()) && common_pb.AuditActor.toObject(includeInstance, f),
    updatedactor: (f = msg.getUpdatedactor()) && common_pb.AuditActor.toObject(includeInstance, f),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantProviderModel}
 */
proto.assistant_api.AssistantProviderModel.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantProviderModel;
  return proto.assistant_api.AssistantProviderModel.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantProviderModel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantProviderModel}
 */
proto.assistant_api.AssistantProviderModel.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = new common_pb.TextChatCompletePrompt;
      reader.readMessage(value,common_pb.TextChatCompletePrompt.deserializeBinaryFromReader);
      msg.setTemplate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAssistantid(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelprovidername(value);
      break;
    case 9:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addAssistantmodeloptions(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 1000:
      var value = new common_pb.AuditActor;
      reader.readMessage(value,common_pb.AuditActor.deserializeBinaryFromReader);
      msg.setCreatedactor(value);
      break;
    case 1001:
      var value = new common_pb.AuditActor;
      reader.readMessage(value,common_pb.AuditActor.deserializeBinaryFromReader);
      msg.setUpdatedactor(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantProviderModel.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantProviderModel.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantProviderModel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantProviderModel.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getTemplate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.TextChatCompletePrompt.serializeBinaryToWriter
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAssistantid();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getModelprovidername();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAssistantmodeloptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCreatedactor();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      common_pb.AuditActor.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedactor();
  if (f != null) {
    writer.writeMessage(
      1001,
      f,
      common_pb.AuditActor.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantProviderModel.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
 */
proto.assistant_api.AssistantProviderModel.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional TextChatCompletePrompt template = 2;
 * @return {?proto.TextChatCompletePrompt}
 */
proto.assistant_api.AssistantProviderModel.prototype.getTemplate = function() {
  return /** @type{?proto.TextChatCompletePrompt} */ (
    jspb.Message.getWrapperField(this, common_pb.TextChatCompletePrompt, 2));
};


/**
 * @param {?proto.TextChatCompletePrompt|undefined} value
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
*/
proto.assistant_api.AssistantProviderModel.prototype.setTemplate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
 */
proto.assistant_api.AssistantProviderModel.prototype.clearTemplate = function() {
  return this.setTemplate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderModel.prototype.hasTemplate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.assistant_api.AssistantProviderModel.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
 */
proto.assistant_api.AssistantProviderModel.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 assistantId = 4;
 * @return {number}
 */
proto.assistant_api.AssistantProviderModel.prototype.getAssistantid = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
 */
proto.assistant_api.AssistantProviderModel.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string modelProviderName = 7;
 * @return {string}
 */
proto.assistant_api.AssistantProviderModel.prototype.getModelprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
 */
proto.assistant_api.AssistantProviderModel.prototype.setModelprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated Metadata assistantModelOptions = 9;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.AssistantProviderModel.prototype.getAssistantmodeloptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 9));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
*/
proto.assistant_api.AssistantProviderModel.prototype.setAssistantmodeloptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.AssistantProviderModel.prototype.addAssistantmodeloptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
 */
proto.assistant_api.AssistantProviderModel.prototype.clearAssistantmodeloptionsList = function() {
  return this.setAssistantmodeloptionsList([]);
};


/**
 * optional string status = 12;
 * @return {string}
 */
proto.assistant_api.AssistantProviderModel.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
 */
proto.assistant_api.AssistantProviderModel.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional AuditActor createdActor = 1000;
 * @return {?proto.AuditActor}
 */
proto.assistant_api.AssistantProviderModel.prototype.getCreatedactor = function() {
  return /** @type{?proto.AuditActor} */ (
    jspb.Message.getWrapperField(this, common_pb.AuditActor, 1000));
};


/**
 * @param {?proto.AuditActor|undefined} value
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
*/
proto.assistant_api.AssistantProviderModel.prototype.setCreatedactor = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
 */
proto.assistant_api.AssistantProviderModel.prototype.clearCreatedactor = function() {
  return this.setCreatedactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderModel.prototype.hasCreatedactor = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional AuditActor updatedActor = 1001;
 * @return {?proto.AuditActor}
 */
proto.assistant_api.AssistantProviderModel.prototype.getUpdatedactor = function() {
  return /** @type{?proto.AuditActor} */ (
    jspb.Message.getWrapperField(this, common_pb.AuditActor, 1001));
};


/**
 * @param {?proto.AuditActor|undefined} value
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
*/
proto.assistant_api.AssistantProviderModel.prototype.setUpdatedactor = function(value) {
  return jspb.Message.setWrapperField(this, 1001, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
 */
proto.assistant_api.AssistantProviderModel.prototype.clearUpdatedactor = function() {
  return this.setUpdatedactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderModel.prototype.hasUpdatedactor = function() {
  return jspb.Message.getField(this, 1001) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantProviderModel.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
*/
proto.assistant_api.AssistantProviderModel.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
 */
proto.assistant_api.AssistantProviderModel.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderModel.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantProviderModel.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
*/
proto.assistant_api.AssistantProviderModel.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderModel} returns this
 */
proto.assistant_api.AssistantProviderModel.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderModel.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 18) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantProviderAgentflow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantProviderAgentflow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantProviderAgentflow.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    assistantid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    schemaversion: jspb.Message.getFieldWithDefault(msg, 4, ""),
    definition: (f = msg.getDefinition()) && google_protobuf_struct_pb.Struct.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 12, ""),
    createdactor: (f = msg.getCreatedactor()) && common_pb.AuditActor.toObject(includeInstance, f),
    updatedactor: (f = msg.getUpdatedactor()) && common_pb.AuditActor.toObject(includeInstance, f),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantProviderAgentflow}
 */
proto.assistant_api.AssistantProviderAgentflow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantProviderAgentflow;
  return proto.assistant_api.AssistantProviderAgentflow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantProviderAgentflow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantProviderAgentflow}
 */
proto.assistant_api.AssistantProviderAgentflow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchemaversion(value);
      break;
    case 5:
      var value = new google_protobuf_struct_pb.Struct;
      reader.readMessage(value,google_protobuf_struct_pb.Struct.deserializeBinaryFromReader);
      msg.setDefinition(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 1000:
      var value = new common_pb.AuditActor;
      reader.readMessage(value,common_pb.AuditActor.deserializeBinaryFromReader);
      msg.setCreatedactor(value);
      break;
    case 1001:
      var value = new common_pb.AuditActor;
      reader.readMessage(value,common_pb.AuditActor.deserializeBinaryFromReader);
      msg.setUpdatedactor(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantProviderAgentflow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantProviderAgentflow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantProviderAgentflow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
  f = message.getSchemaversion();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDefinition();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_struct_pb.Struct.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCreatedactor();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      common_pb.AuditActor.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedactor();
  if (f != null) {
    writer.writeMessage(
      1001,
      f,
      common_pb.AuditActor.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 assistantId = 3;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string schemaVersion = 4;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.getSchemaversion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.setSchemaversion = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Struct definition = 5;
 * @return {?proto.google.protobuf.Struct}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.getDefinition = function() {
  return /** @type{?proto.google.protobuf.Struct} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Struct, 5));
};


/**
 * @param {?proto.google.protobuf.Struct|undefined} value
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
*/
proto.assistant_api.AssistantProviderAgentflow.prototype.setDefinition = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.clearDefinition = function() {
  return this.setDefinition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.hasDefinition = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string status = 12;
 * @return {string}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional AuditActor createdActor = 1000;
 * @return {?proto.AuditActor}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.getCreatedactor = function() {
  return /** @type{?proto.AuditActor} */ (
    jspb.Message.getWrapperField(this, common_pb.AuditActor, 1000));
};


/**
 * @param {?proto.AuditActor|undefined} value
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
*/
proto.assistant_api.AssistantProviderAgentflow.prototype.setCreatedactor = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.clearCreatedactor = function() {
  return this.setCreatedactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.hasCreatedactor = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional AuditActor updatedActor = 1001;
 * @return {?proto.AuditActor}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.getUpdatedactor = function() {
  return /** @type{?proto.AuditActor} */ (
    jspb.Message.getWrapperField(this, common_pb.AuditActor, 1001));
};


/**
 * @param {?proto.AuditActor|undefined} value
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
*/
proto.assistant_api.AssistantProviderAgentflow.prototype.setUpdatedactor = function(value) {
  return jspb.Message.setWrapperField(this, 1001, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.clearUpdatedactor = function() {
  return this.setUpdatedactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.hasUpdatedactor = function() {
  return jspb.Message.getField(this, 1001) != null;
};


/**
 * optional google.protobuf.Timestamp createdDate = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
*/
proto.assistant_api.AssistantProviderAgentflow.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
*/
proto.assistant_api.AssistantProviderAgentflow.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantProviderAgentflow} returns this
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantProviderAgentflow.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 18) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.GetAllAssistantProviderRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAllAssistantProviderRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAllAssistantProviderRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAllAssistantProviderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantProviderRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance),
    assistantid: jspb.Message.getFieldWithDefault(msg, 5, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAllAssistantProviderRequest}
 */
proto.assistant_api.GetAllAssistantProviderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAllAssistantProviderRequest;
  return proto.assistant_api.GetAllAssistantProviderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAllAssistantProviderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAllAssistantProviderRequest}
 */
proto.assistant_api.GetAllAssistantProviderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 2:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAllAssistantProviderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAllAssistantProviderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAllAssistantProviderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantProviderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      5,
      f
    );
  }
};


/**
 * optional Paginate paginate = 1;
 * @return {?proto.Paginate}
 */
proto.assistant_api.GetAllAssistantProviderRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 1));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantProviderRequest} returns this
*/
proto.assistant_api.GetAllAssistantProviderRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantProviderRequest} returns this
 */
proto.assistant_api.GetAllAssistantProviderRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantProviderRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Criteria criterias = 2;
 * @return {!Array<!proto.Criteria>}
 */
proto.assistant_api.GetAllAssistantProviderRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 2));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.assistant_api.GetAllAssistantProviderRequest} returns this
*/
proto.assistant_api.GetAllAssistantProviderRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.assistant_api.GetAllAssistantProviderRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.GetAllAssistantProviderRequest} returns this
 */
proto.assistant_api.GetAllAssistantProviderRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};


/**
 * optional uint64 assistantId = 5;
 * @return {string}
 */
proto.assistant_api.GetAllAssistantProviderRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAllAssistantProviderRequest} returns this
 */
proto.assistant_api.GetAllAssistantProviderRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 5, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.assistant_api.GetAssistantProviderResponse.oneofGroups_ = [[50,51,52,53]];

/**
 * @enum {number}
 */
proto.assistant_api.GetAssistantProviderResponse.DataCase = {
  DATA_NOT_SET: 0,
  ASSISTANTPROVIDERMODEL: 50,
  ASSISTANTPROVIDERAGENTKIT: 51,
  ASSISTANTPROVIDERWEBSOCKET: 52,
  ASSISTANTPROVIDERAGENTFLOW: 53
};

/**
 * @return {proto.assistant_api.GetAssistantProviderResponse.DataCase}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.getDataCase = function() {
  return /** @type {proto.assistant_api.GetAssistantProviderResponse.DataCase} */(jspb.Message.computeOneofCase(this, proto.assistant_api.GetAssistantProviderResponse.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantProviderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantProviderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantProviderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    assistantprovidermodel: (f = msg.getAssistantprovidermodel()) && proto.assistant_api.AssistantProviderModel.toObject(includeInstance, f),
    assistantprovideragentkit: (f = msg.getAssistantprovideragentkit()) && proto.assistant_api.AssistantProviderAgentkit.toObject(includeInstance, f),
    assistantproviderwebsocket: (f = msg.getAssistantproviderwebsocket()) && proto.assistant_api.AssistantProviderWebsocket.toObject(includeInstance, f),
    assistantprovideragentflow: (f = msg.getAssistantprovideragentflow()) && proto.assistant_api.AssistantProviderAgentflow.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantProviderResponse}
 */
proto.assistant_api.GetAssistantProviderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantProviderResponse;
  return proto.assistant_api.GetAssistantProviderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantProviderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantProviderResponse}
 */
proto.assistant_api.GetAssistantProviderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 50:
      var value = new proto.assistant_api.AssistantProviderModel;
      reader.readMessage(value,proto.assistant_api.AssistantProviderModel.deserializeBinaryFromReader);
      msg.setAssistantprovidermodel(value);
      break;
    case 51:
      var value = new proto.assistant_api.AssistantProviderAgentkit;
      reader.readMessage(value,proto.assistant_api.AssistantProviderAgentkit.deserializeBinaryFromReader);
      msg.setAssistantprovideragentkit(value);
      break;
    case 52:
      var value = new proto.assistant_api.AssistantProviderWebsocket;
      reader.readMessage(value,proto.assistant_api.AssistantProviderWebsocket.deserializeBinaryFromReader);
      msg.setAssistantproviderwebsocket(value);
      break;
    case 53:
      var value = new proto.assistant_api.AssistantProviderAgentflow;
      reader.readMessage(value,proto.assistant_api.AssistantProviderAgentflow.deserializeBinaryFromReader);
      msg.setAssistantprovideragentflow(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantProviderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantProviderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantProviderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getAssistantprovidermodel();
  if (f != null) {
    writer.writeMessage(
      50,
      f,
      proto.assistant_api.AssistantProviderModel.serializeBinaryToWriter
    );
  }
  f = message.getAssistantprovideragentkit();
  if (f != null) {
    writer.writeMessage(
      51,
      f,
      proto.assistant_api.AssistantProviderAgentkit.serializeBinaryToWriter
    );
  }
  f = message.getAssistantproviderwebsocket();
  if (f != null) {
    writer.writeMessage(
      52,
      f,
      proto.assistant_api.AssistantProviderWebsocket.serializeBinaryToWriter
    );
  }
  f = message.getAssistantprovideragentflow();
  if (f != null) {
    writer.writeMessage(
      53,
      f,
      proto.assistant_api.AssistantProviderAgentflow.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantProviderModel assistantProviderModel = 50;
 * @return {?proto.assistant_api.AssistantProviderModel}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.getAssistantprovidermodel = function() {
  return /** @type{?proto.assistant_api.AssistantProviderModel} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantProviderModel, 50));
};


/**
 * @param {?proto.assistant_api.AssistantProviderModel|undefined} value
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
*/
proto.assistant_api.GetAssistantProviderResponse.prototype.setAssistantprovidermodel = function(value) {
  return jspb.Message.setOneofWrapperField(this, 50, proto.assistant_api.GetAssistantProviderResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.clearAssistantprovidermodel = function() {
  return this.setAssistantprovidermodel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.hasAssistantprovidermodel = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional AssistantProviderAgentkit assistantProviderAgentkit = 51;
 * @return {?proto.assistant_api.AssistantProviderAgentkit}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.getAssistantprovideragentkit = function() {
  return /** @type{?proto.assistant_api.AssistantProviderAgentkit} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantProviderAgentkit, 51));
};


/**
 * @param {?proto.assistant_api.AssistantProviderAgentkit|undefined} value
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
*/
proto.assistant_api.GetAssistantProviderResponse.prototype.setAssistantprovideragentkit = function(value) {
  return jspb.Message.setOneofWrapperField(this, 51, proto.assistant_api.GetAssistantProviderResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.clearAssistantprovideragentkit = function() {
  return this.setAssistantprovideragentkit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.hasAssistantprovideragentkit = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional AssistantProviderWebsocket assistantProviderWebsocket = 52;
 * @return {?proto.assistant_api.AssistantProviderWebsocket}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.getAssistantproviderwebsocket = function() {
  return /** @type{?proto.assistant_api.AssistantProviderWebsocket} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantProviderWebsocket, 52));
};


/**
 * @param {?proto.assistant_api.AssistantProviderWebsocket|undefined} value
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
*/
proto.assistant_api.GetAssistantProviderResponse.prototype.setAssistantproviderwebsocket = function(value) {
  return jspb.Message.setOneofWrapperField(this, 52, proto.assistant_api.GetAssistantProviderResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.clearAssistantproviderwebsocket = function() {
  return this.setAssistantproviderwebsocket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.hasAssistantproviderwebsocket = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional AssistantProviderAgentflow assistantProviderAgentflow = 53;
 * @return {?proto.assistant_api.AssistantProviderAgentflow}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.getAssistantprovideragentflow = function() {
  return /** @type{?proto.assistant_api.AssistantProviderAgentflow} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantProviderAgentflow, 53));
};


/**
 * @param {?proto.assistant_api.AssistantProviderAgentflow|undefined} value
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
*/
proto.assistant_api.GetAssistantProviderResponse.prototype.setAssistantprovideragentflow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 53, proto.assistant_api.GetAssistantProviderResponse.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.clearAssistantprovideragentflow = function() {
  return this.setAssistantprovideragentflow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.hasAssistantprovideragentflow = function() {
  return jspb.Message.getField(this, 53) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
*/
proto.assistant_api.GetAssistantProviderResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantProviderResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.GetAllAssistantProviderResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAllAssistantProviderResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAllAssistantProviderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantProviderResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse}
 */
proto.assistant_api.GetAllAssistantProviderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAllAssistantProviderResponse;
  return proto.assistant_api.GetAllAssistantProviderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAllAssistantProviderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse}
 */
proto.assistant_api.GetAllAssistantProviderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider;
      reader.readMessage(value,proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAllAssistantProviderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAllAssistantProviderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantProviderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.oneofGroups_ = [[50,51,52,53]];

/**
 * @enum {number}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.AssistantproviderCase = {
  ASSISTANTPROVIDER_NOT_SET: 0,
  ASSISTANTPROVIDERMODEL: 50,
  ASSISTANTPROVIDERAGENTKIT: 51,
  ASSISTANTPROVIDERWEBSOCKET: 52,
  ASSISTANTPROVIDERAGENTFLOW: 53
};

/**
 * @return {proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.AssistantproviderCase}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.getAssistantproviderCase = function() {
  return /** @type {proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.AssistantproviderCase} */(jspb.Message.computeOneofCase(this, proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantprovidermodel: (f = msg.getAssistantprovidermodel()) && proto.assistant_api.AssistantProviderModel.toObject(includeInstance, f),
    assistantprovideragentkit: (f = msg.getAssistantprovideragentkit()) && proto.assistant_api.AssistantProviderAgentkit.toObject(includeInstance, f),
    assistantproviderwebsocket: (f = msg.getAssistantproviderwebsocket()) && proto.assistant_api.AssistantProviderWebsocket.toObject(includeInstance, f),
    assistantprovideragentflow: (f = msg.getAssistantprovideragentflow()) && proto.assistant_api.AssistantProviderAgentflow.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider;
  return proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 50:
      var value = new proto.assistant_api.AssistantProviderModel;
      reader.readMessage(value,proto.assistant_api.AssistantProviderModel.deserializeBinaryFromReader);
      msg.setAssistantprovidermodel(value);
      break;
    case 51:
      var value = new proto.assistant_api.AssistantProviderAgentkit;
      reader.readMessage(value,proto.assistant_api.AssistantProviderAgentkit.deserializeBinaryFromReader);
      msg.setAssistantprovideragentkit(value);
      break;
    case 52:
      var value = new proto.assistant_api.AssistantProviderWebsocket;
      reader.readMessage(value,proto.assistant_api.AssistantProviderWebsocket.deserializeBinaryFromReader);
      msg.setAssistantproviderwebsocket(value);
      break;
    case 53:
      var value = new proto.assistant_api.AssistantProviderAgentflow;
      reader.readMessage(value,proto.assistant_api.AssistantProviderAgentflow.deserializeBinaryFromReader);
      msg.setAssistantprovideragentflow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantprovidermodel();
  if (f != null) {
    writer.writeMessage(
      50,
      f,
      proto.assistant_api.AssistantProviderModel.serializeBinaryToWriter
    );
  }
  f = message.getAssistantprovideragentkit();
  if (f != null) {
    writer.writeMessage(
      51,
      f,
      proto.assistant_api.AssistantProviderAgentkit.serializeBinaryToWriter
    );
  }
  f = message.getAssistantproviderwebsocket();
  if (f != null) {
    writer.writeMessage(
      52,
      f,
      proto.assistant_api.AssistantProviderWebsocket.serializeBinaryToWriter
    );
  }
  f = message.getAssistantprovideragentflow();
  if (f != null) {
    writer.writeMessage(
      53,
      f,
      proto.assistant_api.AssistantProviderAgentflow.serializeBinaryToWriter
    );
  }
};


/**
 * optional AssistantProviderModel assistantProviderModel = 50;
 * @return {?proto.assistant_api.AssistantProviderModel}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.getAssistantprovidermodel = function() {
  return /** @type{?proto.assistant_api.AssistantProviderModel} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantProviderModel, 50));
};


/**
 * @param {?proto.assistant_api.AssistantProviderModel|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider} returns this
*/
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.setAssistantprovidermodel = function(value) {
  return jspb.Message.setOneofWrapperField(this, 50, proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider} returns this
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.clearAssistantprovidermodel = function() {
  return this.setAssistantprovidermodel(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.hasAssistantprovidermodel = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional AssistantProviderAgentkit assistantProviderAgentkit = 51;
 * @return {?proto.assistant_api.AssistantProviderAgentkit}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.getAssistantprovideragentkit = function() {
  return /** @type{?proto.assistant_api.AssistantProviderAgentkit} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantProviderAgentkit, 51));
};


/**
 * @param {?proto.assistant_api.AssistantProviderAgentkit|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider} returns this
*/
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.setAssistantprovideragentkit = function(value) {
  return jspb.Message.setOneofWrapperField(this, 51, proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider} returns this
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.clearAssistantprovideragentkit = function() {
  return this.setAssistantprovideragentkit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.hasAssistantprovideragentkit = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional AssistantProviderWebsocket assistantProviderWebsocket = 52;
 * @return {?proto.assistant_api.AssistantProviderWebsocket}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.getAssistantproviderwebsocket = function() {
  return /** @type{?proto.assistant_api.AssistantProviderWebsocket} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantProviderWebsocket, 52));
};


/**
 * @param {?proto.assistant_api.AssistantProviderWebsocket|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider} returns this
*/
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.setAssistantproviderwebsocket = function(value) {
  return jspb.Message.setOneofWrapperField(this, 52, proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider} returns this
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.clearAssistantproviderwebsocket = function() {
  return this.setAssistantproviderwebsocket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.hasAssistantproviderwebsocket = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional AssistantProviderAgentflow assistantProviderAgentflow = 53;
 * @return {?proto.assistant_api.AssistantProviderAgentflow}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.getAssistantprovideragentflow = function() {
  return /** @type{?proto.assistant_api.AssistantProviderAgentflow} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantProviderAgentflow, 53));
};


/**
 * @param {?proto.assistant_api.AssistantProviderAgentflow|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider} returns this
*/
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.setAssistantprovideragentflow = function(value) {
  return jspb.Message.setOneofWrapperField(this, 53, proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider} returns this
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.clearAssistantprovideragentflow = function() {
  return this.setAssistantprovideragentflow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider.prototype.hasAssistantprovideragentflow = function() {
  return jspb.Message.getField(this, 53) != null;
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated AssistantProvider data = 3;
 * @return {!Array<!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider>}
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider, 3));
};


/**
 * @param {!Array<!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider>} value
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse} returns this
*/
proto.assistant_api.GetAllAssistantProviderResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider=} opt_value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider}
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.assistant_api.GetAllAssistantProviderResponse.AssistantProvider, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse} returns this
*/
proto.assistant_api.GetAllAssistantProviderResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse} returns this
*/
proto.assistant_api.GetAllAssistantProviderResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantProviderResponse} returns this
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantProviderResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.assistant_api);
